/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PermissionsProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Check if the authenticated user has specific permissions or belongs to permission groups
   * @param requestBody
   * @returns any Authorization decisions for each requested permission and group. Each key in the response corresponds to a permission string or group name from the request. The value is either "yes" (user is authorized) or "no" (user is not authorized). Use these decisions to determine whether to proceed with actions or to show/hide UI elements.
   * @throws ApiError
   */
  public postApiServiceauthorizationProcessesPermissionsIsAuthorized(
    requestBody?: {
      /**
       * Array of permission strings to check. Each permission follows the format "resource#action" where resource is the system area (e.g., "workers", "platform", "reports") and action is the specific operation (e.g., "create_worker", "employer_login", "view_analytics"). The response will indicate "yes" if the user has the permission, "no" if they do not.
       */
      permissions?: Array<string>;
      /**
       * Array of permission group names to check. Groups represent broad categories of permissions (e.g., "platform" for platform-level access, "workers" for worker management features, "attendance" for shift management features). The response will indicate "yes" if the user has any permissions in that group, "no" if they do not.
       */
      groups?: Array<string>;
    },
  ): CancelablePromise<{
    /**
     * Object mapping each requested permission or group name to an authorization decision ("yes" or "no")
     */
    data?: Record<string, 'yes' | 'no'>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceauthorization/processes/permissions/is-authorized',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Get roleUuids that have the workers#can_view_all_workers permission for the company
   * @returns any List of roleUuids that have workers#can_view_all_workers
   * @throws ApiError
   */
  public getApiServiceauthorizationProcessesPermissionsRolesWithCanViewAllWorkers(): CancelablePromise<{
    data?: {
      roleUuids?: Array<string>;
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceauthorization/processes/permissions/roles-with-can-view-all-workers',
    });
  }

}
